import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import AppShell from '@/components/layout/AppShell';
import HomePage from '@/pages/HomePage';
import DiyLabPage from '@/pages/DiyLabPage';
import HackDetailPage from '@/pages/HackDetailPage';
import ProductCuratorPage from '@/pages/ProductCuratorPage';
import BeautyProfilePage from '@/pages/BeautyProfilePage';
import FavoritesPage from '@/pages/FavoritesPage';
import LoginPage from '@/pages/LoginPage';
import SignupPage from '@/pages/SignupPage';
import StylingPage from '@/pages/StylingPage';
import NextStepsPage from '@/pages/NextStepsPage';
import CommunityPage from '@/pages/CommunityPage';
import RegimenPage from '@/pages/RegimenPage';
import AskPage from '@/pages/AskPage';
import LifestylePage from '@/pages/LifestylePage';
import CreditsPage from '@/pages/CreditsPage';
import AboutPage from '@/pages/AboutPage';
import PricingPage from '@/pages/PricingPage';
import TermsPage from '@/pages/TermsPage';
import PrivacyPage from '@/pages/PrivacyPage';
import RefundPage from '@/pages/RefundPage';
import ContactPage from '@/pages/ContactPage';
import AdminPage from '@/pages/AdminPage';
import '@/App.css';

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<AppShell />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/diy" element={<DiyLabPage />} />
              <Route path="/diy/:slug" element={<HackDetailPage />} />
              <Route path="/products" element={<ProductCuratorPage />} />
              <Route path="/community" element={<CommunityPage />} />
              <Route
                path="/ask"
                element={
                  <RequireAuth>
                    <AskPage />
                  </RequireAuth>
                }
              />
              <Route
                path="/lifestyle"
                element={
                  <RequireAuth>
                    <LifestylePage />
                  </RequireAuth>
                }
              />
              <Route
                path="/regimen"
                element={
                  <RequireAuth>
                    <RegimenPage />
                  </RequireAuth>
                }
              />
              <Route
                path="/styling"
                element={
                  <RequireAuth>
                    <StylingPage />
                  </RequireAuth>
                }
              />
              <Route
                path="/next-steps"
                element={
                  <RequireAuth>
                    <NextStepsPage />
                  </RequireAuth>
                }
              />
              <Route
                path="/profile"
                element={
                  <RequireAuth>
                    <BeautyProfilePage />
                  </RequireAuth>
                }
              />
              <Route
                path="/favorites"
                element={
                  <RequireAuth>
                    <FavoritesPage />
                  </RequireAuth>
                }
              />
              <Route
                path="/credits"
                element={
                  <RequireAuth>
                    <CreditsPage />
                  </RequireAuth>
                }
              />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/refund" element={<RefundPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route
                path="/admin"
                element={
                  <RequireAuth>
                    <AdminPage />
                  </RequireAuth>
                }
              />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
